module.exports = __webpack_public_path__ + "static/media/ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv.e8c26425.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/ER-PPT1_19_38ZGn_3zxTUXE45Lz3b0gnir0Sw1Tv
// module id = 653
// module chunks = 0